module.exports = __webpack_public_path__ + "static/img/G8_V4.6ce5651.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/captation/img/G8_V4.png
// module id = z55P
// module chunks = 1